<template>
	<v-dialog persistent v-model='showDialog' max-width="1000px">
		<v-card>
			<v-card-title>
				<h2>{{title}}</h2>
			</v-card-title>
			<v-card-text>
				<div v-for="message in errorList" :key="message">
					<v-layout>
						<v-flex xs12 my-1 class="subheading">
							{{message}}
						</v-flex>
					</v-layout>
					<v-divider/>
				</div>
			</v-card-text>
			<v-card-actions>
				<v-spacer/>
				<v-btn color="primary" flat
					@click="$emit('close')">
					Zamknij
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
	export default {
		name: "EgrantyErrorListPopup",

		data() {
			return {
				showDialog: this.isOpen,
			};
		},

		watch: {
			isOpen: {
				immediate: true,
				handler(val) {
					this.showDialog = val;
				},
			},
		},


		props: {
			title: {type: String, default: "Błąd:"},
			errorList: {},
			isOpen: {type: Boolean, default: false},
		},
	};
</script>
